<!-- The closing pitch, full-bleed like the hero: same component, same escape
     from the container, no frame and no rounding on the band itself, so the
     page opens and closes on the same device instead of on a big picture and a
     small floating card. The copy stays on the page's container grid inside it.

     What differs from the hero is what the photograph is doing. The hero's
     picture IS the banner; here the band is ink — the page needs a dark chapter
     to close on, and the footer under it is ink too — and the photograph is a
     framed card sitting on that ground beside the words. A near-white still
     life laid under an ink scrim would be a grey ghost; held in a frame at full
     strength it is the one bright thing on the panel. -->
<app-banner-image
  bannerClasses="cta-banner section-ink"
  bannerImageUrl=""
  [bannerOpacity]="0"
>
  <div class="row align-items-center g-8 g-lg-12 w-100 cta-row">
    <div class="col-12 col-lg-7">
      <span class="eyebrow mb-6">
        <span class="dot"></span>{{ "LANDING_PAGE.CTA.EYEBROW" | translate }}
      </span>

      <h2 class="cta-title fw-bold mb-6">
        {{ "LANDING_PAGE.CTA.HEAD_1" | translate }}<br />
        <span class="mark-spark">{{ "LANDING_PAGE.CTA.HEAD_2" | translate }}</span>
        {{ "LANDING_PAGE.CTA.HEAD_3" | translate }}
      </h2>

      <p class="cta-lead mb-4">{{ "LANDING_PAGE.CTA.BODY_1" | translate }}</p>
      <p class="cta-lead mb-8">{{ "LANDING_PAGE.CTA.BODY_2" | translate }}</p>

      <div class="d-flex flex-wrap gap-3">
        <a class="btn btn-primary btn-lg rounded-pill px-8 fs-4" routerLink="/courses">
          {{ "LANDING_PAGE.ADVICE_BUTTON" | translate }}
        </a>
      </div>
    </div>

    <div class="col-12 col-lg-5">
      <figure class="cta-photo mb-0">
        <img
          src="./assets/media/landing/cta-practice.webp"
          [alt]="'LANDING_PAGE.CTA.HEAD_1' | translate"
          loading="lazy"
        />
      </figure>
    </div>
  </div>
</app-banner-image>
